import dayjs from "dayjs";
import { Flex } from "antd";

import { formatPrice, formatNumber } from "../../../utils/utils";
import Variation from "../../Variation";

import nameDictionary from "../nameDictionary";

export default function renderColumns(locale = "es") {
    return {
        acciones: [
            {
                key: "simbolo",
                title: nameDictionary["simbolo"][locale],
                dataIndex: "simbolo",
                render: (text, record) => (
                    <Flex align="center" gap={12}>
                        {record.logo && <img className="ticker-logo" src={record.logo} alt={record.simbolo} width="24" height="24" />}
                        <strong>{text}</strong>
                    </Flex>
                ),
                sorter: (a, b) => a.simbolo.localeCompare(b.simbolo),
            },
            {
                key: "precioUltimaOperacion",
                title: nameDictionary["precioUltimaOperacion"][locale],
                dataIndex: "precioUltimaOperacion",
                render: (_, record) => formatPrice(record.precioUltimaOperacion, record.moneda || "ARS", locale, "-"),
                sorter: (a, b) => a.precioUltimaOperacion - b.precioUltimaOperacion,
            },
            {
                key: "variacion",
                title: nameDictionary["variacion"][locale],
                dataIndex: "variacion",
                render: (text) => <Variation value={text} />,
                sorter: (a, b) => a.variacion - b.variacion,
            },
            {
                key: "cantidadOperaciones",
                title: nameDictionary["cantidadOperaciones"][locale],
                dataIndex: "cantidadOperaciones",
                responsive: ["lg"],
                render: (text) => formatNumber(text, locale, 0),
                sorter: (a, b) => a.cantidadOperaciones - b.cantidadOperaciones,
            },
            {
                key: "precioApertura",
                title: nameDictionary["precioApertura"][locale],
                dataIndex: "precioApertura",
                responsive: ["lg"],
                render: (_, record) => formatPrice(record.precioApertura, record.moneda || "ARS", locale, "-"),
                sorter: (a, b) => a.precioApertura - b.precioApertura,
            },
            {
                key: "precioMinimo",
                title: nameDictionary["precioMinimo"][locale],
                dataIndex: "precioMinimo",
                responsive: ["xl"],
                render: (_, record) => formatPrice(record.precioMinimo, record.moneda || "ARS", locale, "-"),
                sorter: (a, b) => a.precioMinimo - b.precioMinimo,
            },
            {
                key: "precioMaximo",
                title: nameDictionary["precioMaximo"][locale],
                dataIndex: "precioMaximo",
                responsive: ["xl"],
                render: (_, record) => formatPrice(record.precioMaximo, record.moneda || "ARS", locale, "-"),
                sorter: (a, b) => a.precioMaximo - b.precioMaximo,
            },
            {
                key: "horaUltimaNovedad",
                title: nameDictionary["horaUltimaNovedad"][locale],
                dataIndex: "horaUltimaNovedad",
                responsive: ["md"],
                render: (_, record) => dayjs(`${record.fecha}T${record.horaUltimaNovedad}`).format("L LT"),
                sorter: (a, b) => {
                    return (
                        new Date(`${a.fecha}T${a.horaUltimaNovedad}`) - new Date(`${b.fecha}T${b.horaUltimaNovedad}`)
                    );
                },
            },
        ],

        bonos: [
            {
                key: "simbolo",
                title: nameDictionary["simbolo"][locale],
                dataIndex: "simbolo",
                render: (text, record) => (
                    <Flex align="center" gap={12}>
                        {record.logo && <img className="ticker-logo" src={record.logo} alt={record.simbolo} width="24" height="24" />}
                        <strong>{text}</strong>
                    </Flex>
                ),
                sorter: (a, b) => a.simbolo.localeCompare(b.simbolo),
            },
            {
                key: "precioUltimaOperacion",
                title: nameDictionary["precioUltimaOperacion"][locale],
                dataIndex: "precioUltimaOperacion",
                render: (_, record) => formatPrice(record.precioUltimaOperacion, record.moneda || "ARS", locale, "-"),
                sorter: (a, b) => a.precioUltimaOperacion - b.precioUltimaOperacion,
            },
            {
                key: "variacion",
                title: nameDictionary["variacion"][locale],
                dataIndex: "variacion",
                render: (text) => <Variation value={text} />,
                sorter: (a, b) => a.variacion - b.variacion,
            },
            {
                key: "cantidadOperaciones",
                title: nameDictionary["cantidadOperaciones"][locale],
                dataIndex: "cantidadOperaciones",
                render: (text) => formatNumber(text, locale, 0),
                sorter: (a, b) => a.cantidadOperaciones - b.cantidadOperaciones,
            },
            {
                key: "precioApertura",
                title: nameDictionary["precioApertura"][locale],
                dataIndex: "precioApertura",
                responsive: ["lg"],
                render: (_, record) => formatPrice(record.precioApertura, record.moneda || "ARS", locale, "-"),
                sorter: (a, b) => a.precioApertura - b.precioApertura,
            },
            {
                key: "precioMinimo",
                title: nameDictionary["precioMinimo"][locale],
                dataIndex: "precioMinimo",
                responsive: ["xl"],
                render: (_, record) => formatPrice(record.precioMinimo, record.moneda || "ARS", locale, "-"),
                sorter: (a, b) => a.precioMinimo - b.precioMinimo,
            },
            {
                key: "precioMaximo",
                title: nameDictionary["precioMaximo"][locale],
                dataIndex: "precioMaximo",
                responsive: ["xl"],
                render: (_, record) => formatPrice(record.precioMaximo, record.moneda || "ARS", locale, "-"),
                sorter: (a, b) => a.precioMaximo - b.precioMaximo,
            },
            {
                key: "horaUltimaNovedad",
                title: nameDictionary["horaUltimaNovedad"][locale],
                dataIndex: "horaUltimaNovedad",
                responsive: ["md"],
                render: (_, record) => dayjs(`${record.fecha}T${record.horaUltimaNovedad}`).format("L LT"),
                sorter: (a, b) => {
                    return (
                        new Date(`${a.fecha}T${a.horaUltimaNovedad}`) - new Date(`${b.fecha}T${b.horaUltimaNovedad}`)
                    );
                },
            },
        ],

        cauciones: [
            {
                key: "plazo",
                title: nameDictionary["cantidadDias"][locale],
                dataIndex: "plazo",
                render: (text, record) => <p><strong>{text}</strong> {record.moneda}</p>,
                sorter: (a, b) => a.plazo - b.plazo,
            },
            {
                key: "precioUltimaOperacion",
                title: nameDictionary["ultimaOperacion"][locale],
                dataIndex: "precioUltimaOperacion",
                responsive: ["md"],
                render: (_, record) => `${formatNumber(record.precioUltimaOperacion, locale, 2)}%`,
                sorter: (a, b) => a.precioUltimaOperacion - b.precioUltimaOperacion,
            },
            {
                key: "variacion",
                title: nameDictionary["variacion"][locale],
                dataIndex: "variacion",
                render: (text) => <Variation value={text} />,
                sorter: (a, b) => a.variacion - b.variacion,
            },
            {
                key: "cantidadCompra",
                title: nameDictionary["montoTOM"][locale],
                dataIndex: "cantidadCompra",
                render: (text) => formatNumber(text, locale, 2),
                sorter: (a, b) => a.cantidadCompra - b.cantidadCompra,
            },
            {
                key: "precioMejorOrdenCompra",
                title: nameDictionary["TNATOM"][locale],
                dataIndex: "precioMejorOrdenCompra",
                responsive: ["sm"],
                render: (_, record) => `${formatNumber(record.precioMejorOrdenCompra, locale, 2)}%`,
                sorter: (a, b) => a.precioMejorOrdenCompra - b.precioMejorOrdenCompra,
            },
            {
                key: "precioMejorOrdenVenta",
                title: nameDictionary["TNACOL"][locale],
                dataIndex: "precioMejorOrdenVenta",
                responsive: ["sm"],
                render: (_, record) => `${formatNumber(record.precioMejorOrdenVenta, locale, 2)}%`,
                sorter: (a, b) => a.precioMejorOrdenVenta - b.precioMejorOrdenVenta,
            },
            {
                key: "cantidadVenta",
                title: nameDictionary["montoCOL"][locale],
                dataIndex: "cantidadVenta",
                render: (text) => formatNumber(text, locale, 2),
                sorter: (a, b) => a.cantidadVenta - b.cantidadVenta,
            },
            {
                key: "montoOperado",
                title: nameDictionary["volumen"][locale],
                dataIndex: "montoOperado",
                render: (text) => formatNumber(text, locale, 2),
                sorter: (a, b) => a.montoOperado - b.montoOperado,
            },
            {
                key: "fechaVencimiento",
                title: nameDictionary["fechaVto"][locale],
                dataIndex: "fechaVencimiento",
                responsive: ["sm"],
                render: (text) => dayjs(text).format("L"),
                sorter: (a, b) => {
                    return new Date(a.fechaVencimiento) - new Date(b.fechaVencimiento);
                },
            },
            {
                key: "precioApertura",
                title: nameDictionary["precioAper"][locale],
                dataIndex: "precioApertura",
                responsive: ["sm"],
                render: (_, record) => `${formatNumber(record.precioApertura, locale, 2)}%`,
                sorter: (a, b) => a.precioApertura - b.precioApertura,
            },
            {
                key: "precioMinimo",
                title: nameDictionary["precioMin"][locale],
                dataIndex: "precioMinimo",
                responsive: ["xl"],
                render: (_, record) => `${formatNumber(record.precioMinimo, locale, 2)}%`,
                sorter: (a, b) => a.precioMinimo - b.precioMinimo,
            },
            {
                key: "precioMaximo",
                title: nameDictionary["precioMax"][locale],
                dataIndex: "precioMaximo",
                responsive: ["xl"],
                render: (_, record) => `${formatNumber(record.precioMaximo, locale, 2)}%`,
                sorter: (a, b) => a.precioMaximo - b.precioMaximo,
            },
            {
                key: "precioCierreAnterior",
                title: nameDictionary["cierreAnt"][locale],
                dataIndex: "precioCierreAnterior",
                responsive: ["xl"],
                render: (_, record) => `${formatNumber(record.precioCierreAnterior, locale, 2)}%`,
                orter: (a, b) => a.precioCierreAnterior - b.precioCierreAnterior,
            },
            {
                key: "horaUltimaNovedad",
                title: nameDictionary["ultimaAct"][locale],
                dataIndex: "horaUltimaNovedad",
                responsive: ["md"],
                render: (text, record) => dayjs(`${record.fecha}T${record.horaUltimaNovedad}`).format("L LT"),
                sorter: (a, b) => {
                    return (
                        new Date(`${a.fecha}T${a.horaUltimaNovedad}`) - new Date(`${b.fecha}T${b.horaUltimaNovedad}`)
                    );
                },
            },
        ],

        cedears: [
            {
                key: "simbolo",
                title: nameDictionary["simbolo"][locale],
                dataIndex: "simbolo",
                render: (text, record) => (
                    <Flex align="center" gap={12}>
                        {record.logo && <img className="ticker-logo" src={record.logo} alt={record.simbolo} width="24" height="24" />}
                        <strong>{text}</strong>
                    </Flex>
                ),
                sorter: (a, b) => a.simbolo.localeCompare(b.simbolo),
            },
            {
                key: "precioUltimaOperacion",
                title: nameDictionary["precioUltimaOperacion"][locale],
                dataIndex: "precioUltimaOperacion",
                render: (_, record) => formatPrice(record.precioUltimaOperacion, record.moneda || "ARS", locale, "-"),
                sorter: (a, b) => a.precioUltimaOperacion - b.precioUltimaOperacion,
            },
            {
                key: "variacion",
                title: nameDictionary["variacion"][locale],
                dataIndex: "variacion",
                render: (text) => <Variation value={text} />,
                sorter: (a, b) => a.variacion - b.variacion,
            },
            {
                key: "cantidadOperaciones",
                title: nameDictionary["cantidadOperaciones"][locale],
                dataIndex: "cantidadOperaciones",
                responsive: ["lg"],
                render: (text) => formatNumber(text, locale, 0),
                sorter: (a, b) => a.cantidadOperaciones - b.cantidadOperaciones,
            },
            {
                key: "precioApertura",
                title: nameDictionary["precioApertura"][locale],
                dataIndex: "precioApertura",
                responsive: ["lg"],
                render: (_, record) => formatPrice(record.precioApertura, record.moneda || "ARS", locale, "-"),
                sorter: (a, b) => a.precioApertura - b.precioApertura,
            },
            {
                key: "precioMinimo",
                title: nameDictionary["precioMinimo"][locale],
                dataIndex: "precioMinimo",
                responsive: ["xl"],
                render: (_, record) => formatPrice(record.precioMinimo, record.moneda || "ARS", locale, "-"),
                sorter: (a, b) => a.precioMinimo - b.precioMinimo,
            },
            {
                key: "precioMaximo",
                title: nameDictionary["precioMaximo"][locale],
                dataIndex: "precioMaximo",
                responsive: ["xl"],
                render: (_, record) => formatPrice(record.precioMaximo, record.moneda || "ARS", locale, "-"),
                sorter: (a, b) => a.precioMaximo - b.precioMaximo,
            },
            {
                key: "horaUltimaNovedad",
                title: nameDictionary["horaUltimaNovedad"][locale],
                dataIndex: "horaUltimaNovedad",
                responsive: ["md"],
                render: (_, record) => dayjs(`${record.fecha}T${record.horaUltimaNovedad}`).format("L LT"),
                sorter: (a, b) => {
                    return (
                        new Date(`${a.fecha}T${a.horaUltimaNovedad}`) - new Date(`${b.fecha}T${b.horaUltimaNovedad}`)
                    );
                },
            },
        ],

        cheques: [
            {
                key: "segmento",
                title: nameDictionary["segmento"][locale],
                dataIndex: "segmento",
                fixed: "left",
                render: (text, record) => (
                    <Flex align="center" gap={12}>
                        {record.logo && <img className="ticker-logo" src={record.logo} alt={record.subastaNumero} width="24" height="24" />}
                        <div>
                            <span className="small-text">N° {record.subastaNumero}</span>
                            <br />
                            <strong>{text}</strong>
                        </div>
                    </Flex>
                ),
                sorter: (a, b) => a.segmento.localeCompare(b.segmento),
            },
            {
                key: "horario",
                title: nameDictionary["horario"][locale],
                dataIndex: "horario",
                render: (text, record) => (
                    <>
                        {dayjs(`${dayjs().format("YYYY-MM-DD")}T${record.horarioMinimo}`).format("LT")} / {dayjs(`${dayjs().format("YYYY-MM-DD")}T${record.horarioMaximo}`).format("LT")}
                    </>
                )
            },
            {
                key: "plazo",
                title: nameDictionary["plazo"][locale],
                dataIndex: "plazo",
                sorter: (a, b) => a.plazo - b.plazo,
            },
            {
                key: "oferta",
                title: nameDictionary["oferta"][locale],
                dataIndex: "oferta",
                render: (_, record) => (
                    <>
                        {formatPrice(record.ofertaCompra, record.moneda || "ARS", locale, "-")} / {formatPrice(record.ofertaVenta, record.moneda || "ARS", locale, "-")}
                    </>
                )
            },
            {
                key: "valorNominal",
                title: nameDictionary["valorNominal"][locale],
                dataIndex: "valorNominal",
                render: (_, record) => formatPrice(record.valorNominal, record.moneda || "ARS", locale, "-"),
                sorter: (a, b) => a.valorNominal - b.valorNominal,
            },
            {
                key: "chequeNumero",
                title: nameDictionary["chequeNumero"][locale],
                dataIndex: "chequeNumero",
                sorter: (a, b) => a.chequeNumero - b.chequeNumero,
            },
            {
                key: "estado",
                title: nameDictionary["estado"][locale],
                dataIndex: "estado",
                sorter: (a, b) => a.estado.localeCompare(b.estado),
            },
            {
                key: "sgrLibradorAlmacenadora",
                title: nameDictionary["sgrLibradorAlmacenadora"][locale],
                dataIndex: "sgrLibradorAlmacenadora",
                sorter: (a, b) => a.sgrLibradorAlmacenadora.localeCompare(b.sgrLibradorAlmacenadora),
            },
            {
                key: "montoAInvertir",
                title: nameDictionary["montoAInvertir"][locale],
                dataIndex: "montoAInvertir",
                render: (_, record) => formatPrice(record.montoAInvertir, record.moneda || "ARS", locale, "-"),
                sorter: (a, b) => a.montoAInvertir - b.montoAInvertir,
            },
        ],

        fondos: [
            {
                key: "descripcion",
                title: nameDictionary["descripcion"][locale],
                dataIndex: "descripcion",
                render: (text) => <strong>{text}</strong>,
                sorter: (a, b) => a.descripcion.localeCompare(b.descripcion),
            },
            {
                key: "clase",
                title: nameDictionary["clase"][locale],
                dataIndex: "clase",
                render: (text) => text,
                sorter: (a, b) => a.clase.localeCompare(b.clase),
            },
            {
                key: "tipo",
                title: nameDictionary["tipo"][locale],
                dataIndex: "tipo",
                render: (text) => text,
                sorter: (a, b) => a.tipo.localeCompare(b.tipo),
            },
            {
                key: "moneda",
                title: nameDictionary["moneda"][locale],
                dataIndex: "moneda",
                responsive: ["lg"],
                render: (text) => text,
                sorter: (a, b) => a.moneda.localeCompare(b.moneda),
            },
            {
                key: "plazoRescate",
                title: nameDictionary["plazoRescate"][locale],
                dataIndex: "plazoRescate",
                responsive: ["sm"],
                render: (text) => text,
                sorter: (a, b) => a.plazoRescate.localeCompare(b.plazoRescate),
            },
            {
                key: "ytd",
                title: nameDictionary["ytd"][locale],
                dataIndex: "ytd",
                responsive: ["md"],
                render: (_, record) => <Variation value={record.variacion.ytd} />,
                sorter: (a, b) => a.variacion.ytd - b.variacion.ytd,
            },
            {
                key: "lastMonth",
                title: nameDictionary["lastMonth"][locale],
                dataIndex: "lastMonth",
                render: (_, record) => <Variation value={record.variacion.meses1} />,
                sorter: (a, b) => a.variacion.meses1 - b.variacion.meses1,
            },
            {
                key: "last12Months",
                title: nameDictionary["last12Months"][locale],
                dataIndex: "last12Months",
                responsive: ["xl"],
                render: (_, record) => <Variation value={record.variacion.meses12} />,
                sorter: (a, b) => a.variacion.meses12 - b.variacion.meses12,
            },
        ],

        futuros: [
            {
                key: "simbolo",
                title: nameDictionary["simbolo"][locale],
                dataIndex: "simbolo",
                render: (text, record) => (
                    <Flex align="center" gap={12}>
                        {record.logo && <img className="ticker-logo" src={record.logo} alt={record.simbolo} width="24" height="24" />}
                        <div>
                            <strong>{text}</strong>
                            <br />
                            <span className="small-text">
                                {locale === "es" ? "Venc. " : "Exp. "}
                                {dayjs(record.fechaVencimiento).format("L")}
                            </span>
                        </div>
                    </Flex>
                ),
                sorter: (a, b) => a.simbolo.localeCompare(b.simbolo),
            },
            {
                key: "precioUltimaOperacion",
                title: nameDictionary["precioUltimaOperacion"][locale],
                dataIndex: "precioUltimaOperacion",
                render: (_, record) => formatPrice(record.precioUltimaOperacion, record.moneda || "ARS", locale, "-"),
                sorter: (a, b) => a.precioUltimaOperacion - b.precioUltimaOperacion,
            },
            {
                key: "variacion",
                title: nameDictionary["variacion"][locale],
                dataIndex: "variacion",
                render: (text) => <Variation value={text} />,
                sorter: (a, b) => a.variacion - b.variacion,
            },
            {
                key: "cantidadOperaciones",
                title: nameDictionary["cantidadOperaciones"][locale],
                dataIndex: "cantidadOperaciones",
                responsive: ["sm"],
                render: (text) => formatNumber(text, locale, 0),
                sorter: (a, b) => a.cantidadOperaciones - b.cantidadOperaciones,
            },
            {
                key: "precioApertura",
                title: nameDictionary["precioApertura"][locale],
                dataIndex: "precioApertura",
                responsive: ["lg"],
                render: (_, record) => formatPrice(record.precioApertura, record.moneda || "ARS", locale, "-"),
                sorter: (a, b) => a.precioApertura - b.precioApertura,
            },
            {
                key: "precioMinimo",
                title: nameDictionary["precioMinimo"][locale],
                dataIndex: "precioMinimo",
                responsive: ["xl"],
                render: (_, record) => formatPrice(record.precioMinimo, record.moneda || "ARS", locale, "-"),
                sorter: (a, b) => a.precioMinimo - b.precioMinimo,
            },
            {
                key: "precioMaximo",
                title: nameDictionary["precioMaximo"][locale],
                dataIndex: "precioMaximo",
                responsive: ["xl"],
                render: (_, record) => formatPrice(record.precioMaximo, record.moneda || "ARS", locale, "-"),
                sorter: (a, b) => a.precioMaximo - b.precioMaximo,
            },
            {
                key: "horaUltimaNovedad",
                title: nameDictionary["horaUltimaNovedad"][locale],
                dataIndex: "horaUltimaNovedad",
                responsive: ["md"],
                render: (text, record) => dayjs(`${record.fecha}T${record.horaUltimaNovedad}`).format("L LT"),
                sorter: (a, b) => {
                    return (
                        new Date(`${a.fecha}T${a.horaUltimaNovedad}`) - new Date(`${b.fecha}T${b.horaUltimaNovedad}`)
                    );
                },
            },
        ],

        letra: [
            {
                key: "simbolo",
                title: nameDictionary["simbolo"][locale],
                dataIndex: "simbolo",
                render: (text, record) => (
                    <Flex align="center" gap={12}>
                        {record.logo && <img className="ticker-logo" src={record.logo} alt={record.simbolo} width="24" height="24" />}
                        <div>
                            <strong>{text}</strong>
                        </div>
                    </Flex>
                ),
                sorter: (a, b) => a.simbolo.localeCompare(b.simbolo),
            },
            {
                key: "precioUltimaOperacion",
                title: nameDictionary["precioUltimaOperacion"][locale],
                dataIndex: "precioUltimaOperacion",
                render: (_, record) => formatPrice(record.precioUltimaOperacion, record.moneda || "ARS", locale, "-"),
                sorter: (a, b) => a.precioUltimaOperacion - b.precioUltimaOperacion,
            },
            {
                key: "variacion",
                title: nameDictionary["variacion"][locale],
                dataIndex: "variacion",
                render: (text) => <Variation value={text} />,
                sorter: (a, b) => a.variacion - b.variacion,
            },
            {
                key: "cantidadOperaciones",
                title: nameDictionary["cantidadOperaciones"][locale],
                dataIndex: "cantidadOperaciones",
                responsive: ["sm"],
                render: (text) => formatNumber(text, locale, 0),
                sorter: (a, b) => a.cantidadOperaciones - b.cantidadOperaciones,
            },
            {
                key: "precioApertura",
                title: nameDictionary["precioApertura"][locale],
                dataIndex: "precioApertura",
                responsive: ["lg"],
                render: (_, record) => formatPrice(record.precioApertura, record.moneda || "ARS", locale, "-"),
                sorter: (a, b) => a.precioApertura - b.precioApertura,
            },
            {
                key: "precioMinimo",
                title: nameDictionary["precioMinimo"][locale],
                dataIndex: "precioMinimo",
                responsive: ["xl"],
                render: (_, record) => formatPrice(record.precioMinimo, record.moneda || "ARS", locale, "-"),
                sorter: (a, b) => a.precioMinimo - b.precioMinimo,
            },
            {
                key: "precioMaximo",
                title: nameDictionary["precioMaximo"][locale],
                dataIndex: "precioMaximo",
                responsive: ["xl"],
                render: (_, record) => formatPrice(record.precioMaximo, record.moneda || "ARS", locale, "-"),
                sorter: (a, b) => a.precioMaximo - b.precioMaximo,
            },
            {
                key: "horaUltimaNovedad",
                title: nameDictionary["horaUltimaNovedad"][locale],
                dataIndex: "horaUltimaNovedad",
                responsive: ["md"],
                render: (text, record) => dayjs(`${record.fecha}T${record.horaUltimaNovedad}`).format("L LT"),
                sorter: (a, b) => {
                    return (
                        new Date(`${a.fecha}T${a.horaUltimaNovedad}`) - new Date(`${b.fecha}T${b.horaUltimaNovedad}`)
                    );
                },
            },
        ],

        obligacionesnegoc: [
            {
                key: "simbolo",
                title: nameDictionary["simbolo"][locale],
                dataIndex: "simbolo",
                render: (text, record) => (
                    <Flex align="center" gap={12}>
                        {record.logo && <img className="ticker-logo" src={record.logo} alt={record.simbolo} width="24" height="24" />}
                        <div>
                            <strong>{text}</strong>
                        </div>
                    </Flex>
                ),
                sorter: (a, b) => a.simbolo.localeCompare(b.simbolo),
            },
            {
                key: "precioUltimaOperacion",
                title: nameDictionary["precioUltimaOperacion"][locale],
                dataIndex: "precioUltimaOperacion",
                render: (_, record) => formatPrice(record.precioUltimaOperacion, record.moneda || "ARS", locale, "-"),
                sorter: (a, b) => a.precioUltimaOperacion - b.precioUltimaOperacion,
            },
            {
                key: "variacion",
                title: nameDictionary["variacion"][locale],
                dataIndex: "variacion",
                render: (text) => <Variation value={text} />,
                sorter: (a, b) => a.variacion - b.variacion,
            },
            {
                key: "cantidadOperaciones",
                title: nameDictionary["cantidadOperaciones"][locale],
                dataIndex: "cantidadOperaciones",
                responsive: ["sm"],
                render: (text) => formatNumber(text, locale, 0),
                sorter: (a, b) => a.cantidadOperaciones - b.cantidadOperaciones,
            },
            {
                key: "precioApertura",
                title: nameDictionary["precioApertura"][locale],
                dataIndex: "precioApertura",
                responsive: ["lg"],
                render: (_, record) => formatPrice(record.precioApertura, record.moneda || "ARS", locale, "-"),
                sorter: (a, b) => a.precioApertura - b.precioApertura,
            },
            {
                key: "precioMinimo",
                title: nameDictionary["precioMinimo"][locale],
                dataIndex: "precioMinimo",
                responsive: ["xl"],
                render: (_, record) => formatPrice(record.precioMinimo, record.moneda || "ARS", locale, "-"),
                sorter: (a, b) => a.precioMinimo - b.precioMinimo,
            },
            {
                key: "precioMaximo",
                title: nameDictionary["precioMaximo"][locale],
                dataIndex: "precioMaximo",
                responsive: ["xl"],
                render: (_, record) => formatPrice(record.precioMaximo, record.moneda || "ARS", locale, "-"),
                sorter: (a, b) => a.precioMaximo - b.precioMaximo,
            },
            {
                key: "horaUltimaNovedad",
                title: nameDictionary["horaUltimaNovedad"][locale],
                dataIndex: "horaUltimaNovedad",
                responsive: ["md"],
                render: (text, record) => dayjs(`${record.fecha}T${record.horaUltimaNovedad}`).format("L LT"),
                sorter: (a, b) => {
                    return (
                        new Date(`${a.fecha}T${a.horaUltimaNovedad}`) - new Date(`${b.fecha}T${b.horaUltimaNovedad}`)
                    );
                },
            },
        ],

        opciones: [
            {
                key: "simbolo",
                title: nameDictionary["simbolo"][locale],
                dataIndex: "simbolo",
                render: (text, record) => (
                    <Flex align="center" gap={12}>
                        {record.logo && <img className="ticker-logo" src={record.logo} alt={record.simbolo} width="24" height="24" />}
                        <strong>{text}</strong>
                    </Flex>
                ),
                sorter: (a, b) => a.simbolo.localeCompare(b.simbolo),
            },
            {
                key: "precioUltimaOperacion",
                title: nameDictionary["precioUltimaOperacion"][locale],
                dataIndex: "precioUltimaOperacion",
                render: (_, record) => formatPrice(record.precioUltimaOperacion, record.moneda || "ARS", locale, "-"),
                sorter: (a, b) => a.precioUltimaOperacion - b.precioUltimaOperacion,
            },
            {
                key: "variacion",
                title: nameDictionary["variacion"][locale],
                dataIndex: "variacion",
                render: (text) => <Variation value={text} />,
                sorter: (a, b) => a.variacion - b.variacion,
            },
            {
                key: "cantidadOperaciones",
                title: nameDictionary["cantidadOperaciones"][locale],
                dataIndex: "cantidadOperaciones",
                responsive: ["lg"],
                render: (text) => formatNumber(text, locale, 0),
                sorter: (a, b) => a.cantidadOperaciones - b.cantidadOperaciones,
            },
            {
                key: "precioApertura",
                title: nameDictionary["precioApertura"][locale],
                dataIndex: "precioApertura",
                responsive: ["md"],
                render: (_, record) => formatPrice(record.precioApertura, record.moneda || "ARS", locale, "-"),
                sorter: (a, b) => a.precioApertura - b.precioApertura,
            },
            {
                key: "precioMinimo",
                title: nameDictionary["precioMinimo"][locale],
                dataIndex: "precioMinimo",
                responsive: ["xl"],
                render: (_, record) => formatPrice(record.precioMinimo, record.moneda || "ARS", locale, "-"),
                sorter: (a, b) => a.precioMinimo - b.precioMinimo,
            },
            {
                key: "precioMaximo",
                title: nameDictionary["precioMaximo"][locale],
                dataIndex: "precioMaximo",
                responsive: ["xl"],
                render: (_, record) => formatPrice(record.precioMaximo, record.moneda || "ARS", locale, "-"),
                sorter: (a, b) => a.precioMaximo - b.precioMaximo,
            },
            {
                key: "precioCierreAnterior",
                title: nameDictionary["precioCierreAnterior"][locale],
                dataIndex: "precioCierreAnterior",
                responsive: ["md"],
                render: (_, record) => formatPrice(record.precioCierreAnterior, record.moneda || "ARS", locale, "-"),
                orter: (a, b) => a.precioCierreAnterior - b.precioCierreAnterior,
            },
            {
                key: "horaUltimaNovedad",
                title: nameDictionary["horaUltimaNovedad"][locale],
                dataIndex: "horaUltimaNovedad",
                responsive: ["md"],
                render: (text, record) => dayjs(`${record.fecha}T${record.horaUltimaNovedad}`).format("L LT"),
                sorter: (a, b) => {
                    return (
                        new Date(`${a.fecha}T${a.horaUltimaNovedad}`) - new Date(`${b.fecha}T${b.horaUltimaNovedad}`)
                    );
                },
            },
        ],

        pagares: [
            {
                key: "segmento",
                title: nameDictionary["segmento"][locale],
                dataIndex: "segmento",
                fixed: "left",
                render: (text, record) => (
                    <Flex align="center" gap={12}>
                        {record.logo && <img className="ticker-logo" src={record.logo} alt={record.subastaNumero} width="24" height="24" />}
                        <div>
                            <span className="small-text">N° {record.subastaNumero}</span>
                            <br />
                            <strong>{text}</strong>
                        </div>
                    </Flex>
                ),
                sorter: (a, b) => a.segmento.localeCompare(b.segmento),
            },
            {
                key: "horario",
                title: nameDictionary["horario"][locale],
                dataIndex: "horario",
                render: (text, record) => (
                    <>
                        {dayjs(`${dayjs().format("YYYY-MM-DD")}T${record.horarioMinimo}`).format("LT")} / {dayjs(`${dayjs().format("YYYY-MM-DD")}T${record.horarioMaximo}`).format("LT")}
                    </>
                )
            },
            {
                key: "plazo",
                title: nameDictionary["plazo"][locale],
                dataIndex: "plazo",
                sorter: (a, b) => a.plazo - b.plazo,
            },
            {
                key: "oferta",
                title: nameDictionary["oferta"][locale],
                dataIndex: "oferta",
                render: (_, record) => (
                    <>
                        {formatPrice(record.ofertaCompra, record.moneda || "ARS", locale, "-")} / {formatPrice(record.ofertaVenta, record.moneda || "ARS", locale, "-")}
                    </>
                )
            },
            {
                key: "valorNominal",
                title: nameDictionary["valorNominal"][locale],
                dataIndex: "valorNominal",
                render: (_, record) => formatPrice(record.valorNominal, record.moneda || "ARS", locale, "-"),
                sorter: (a, b) => a.valorNominal - b.valorNominal,
            },
            {
                key: "chequeNumero",
                title: nameDictionary["chequeNumero"][locale],
                dataIndex: "chequeNumero",
                sorter: (a, b) => a.chequeNumero - b.chequeNumero,
            },
            {
                key: "estado",
                title: nameDictionary["estado"][locale],
                dataIndex: "estado",
                sorter: (a, b) => a.estado.localeCompare(b.estado),
            },
            {
                key: "sgrLibradorAlmacenadora",
                title: nameDictionary["sgrLibradorAlmacenadora"][locale],
                dataIndex: "sgrLibradorAlmacenadora",
                sorter: (a, b) => a.sgrLibradorAlmacenadora.localeCompare(b.sgrLibradorAlmacenadora),
            },
            {
                key: "montoAInvertir",
                title: nameDictionary["montoAInvertir"][locale],
                dataIndex: "montoAInvertir",
                render: (_, record) => formatPrice(record.montoAInvertir, record.moneda || "ARS", locale, "-"),
                sorter: (a, b) => a.montoAInvertir - b.montoAInvertir,
            },
        ]
    };
}
